








































































import Vue from 'vue';
import { mapState } from 'vuex';
import HMTableButton from '@/web/components/common/HMTableButton.vue';
import moment from 'moment';
import { saveAs } from '@/web/utils/save-file';
import { errorToMessage } from '@/core/utils/errors';
import PaymentPlanInvoicesModal from '@/web/components/payment-plans/PaymentPlanInvoicesModal.vue';

export default Vue.extend({
  components: {
    HMTableButton,
  },
  computed: {
    ...mapState('user', ['purchases']),
    isPaymentPlanPastDue() {
      if (!this.purchases) return false;
      return this.purchases.some(
        purchase => purchase.reference_payment_plan?.status === 'past_due'
      );
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('LL');
    },
    async downloadStudentPurchaseInvoice(purchase) {
      try {
        const data = await this.$store.dispatch(
          'user/downloadStudentPurchaseInvoice',
          purchase.id
        );
        const blob = new Blob([data], {
          type: 'application/pdf;charset=utf-8;',
        });
        saveAs(blob, `order-${purchase.id}.pdf`);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Downloading invoice failed',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    selectPaymentPlan(paymentPlan) {
      this.$modal.show(PaymentPlanInvoicesModal, {
        paymentPlan: paymentPlan,
        student: true,
      });
    },
  },
  mounted() {
    this.$store.dispatch('user/studentPurchases');
  },
});
